const routes = [
    {
      path: '/fundings',
      name: 'fundings',
      meta: {
        adminUser: true,
        title: 'VLAMS - Fundings'
      },
      component: () => import('@/views/Fundings.vue')
    },
    {
      path: '/reportings',
      name: 'reportings',
      meta: {
        adminUser: true,
        title: 'VLAMS - Reporting'
      },
      component: () => import('@/views/Reportings.vue')
    }
  ]

  export default routes
